import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";
import {
  CategoryBrandSchema,
  CategoryBrandsParams,
} from "src/models/categoryBrand/types";
import { paramsSerializer } from "src/utils/helpers/paramsSerializer/paramsSerializer";

export const getCategoryBrand = (params: CategoryBrandsParams) =>
  setInstanceByEnvType().get<CategoryBrandSchema>("v2/catalog/brand_page", {
    params,
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "0",
    },
    paramsSerializer: paramsSerializer,
  });
